module.exports = __webpack_public_path__ + "img/Apoptosis-PDAC_GSE111672.3e555693.png";